module.exports = __webpack_public_path__ + "images/a6f47eb9.minionsLogo.png";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/orderLocation/images/minionsLogo.png
// module id = 551
// module chunks = 99